import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const manifestReturnedProduct = unaryRpc({
  name: "manifestReturnedProduct" as const,
  input: z.object({
    returnId: z.string(),
    returnProductId: z.string(),
    targetTeamId: z.string(),
    locationId: z.string(),
    quantity: z.number(),
  }),
  output: z.object({ productId: z.string() }),
});
